
export function Footer() {

return (
<footer className="site-footer">
    <div className="site-footer-accent-line"></div>

    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-col-brand">
          <a href="/" className="footer-logo-link">
            <img src="https://cdn.yutongoriginal.ru/images/logo.png" alt="Yutong Original" />
          </a>

          <p>Оригинальные запасные части для автобусов Yutong. Склад в Санкт-Петербурге, надежная доставка по всей
            России.</p>

          <div className="footer-social">
            <a href="https://wa.me/79819656888" className="social-btn" title="WhatsApp" target="_blank">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </a>
            <a href="t.me/SKyznetsov" className="social-btn" title="Telegram" target="_blank">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
              </svg>
            </a>
            <a href="weixin://dl/chat?{towxid_ojzb4oeeuuj022}" className="social-btn" title="WeChat" target="_blank">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z" />
              </svg>
            </a>
            <a href="https://max.ru/u/f9LHodD0cOJ5qf6iKgjiw99Fc04YQJ934KGXLGFiATMaYYA8jdDpsRJFMW4" className="social-btn" title="MAX" target="_blank">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.5 2C18.3 2 23 6.7 23 12.5C23 18.3 18.3 23 12.5 23C10.4 23 8.4 22.4 6.8 21.3L2.8 22.3C2 22.5 1.5 22 1.7 21.2L2.7 17.2C1.6 15.6 1 13.6 1 12.5C1 6.7 6.2 2 12.5 2ZM12.5 6.5C9.2 6.5 6.5 9.2 6.5 12.5C6.5 14 7 15.3 7.9 16.3L6 18L8.2 16.7C9.3 17.8 10.8 18.5 12.5 18.5C15.8 18.5 18.5 15.8 18.5 12.5C18.5 9.2 15.8 6.5 12.5 6.5Z"
                  fill="currentColor" fill-rule="evenodd" />
              </svg> 
            </a>
          </div>
        </div>
        <div className="footer-col">
          <h4>Навигация</h4>
          <ul>
            <li><a href="/all">Каталог запчастей</a></li>
            <li><a href="/about">О нас</a></li>
            <li><a href="/delivery">Доставка и оплата</a></li>
            <li><a href="/contacts">Контакты</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Информация</h4>
          <ul>
            <li><a href="/policy">Гарантия</a></li>
            <li><a href="/policy">Возврат товара</a></li>
            <li><a href="/page/yutong">О Yutong Original</a></li>
            <li><a href="/page/models">Модельный ряд Yutong</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Контакты</h4>
          <div className="contact-item">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path
                  d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.63a19.79 19.79 0 01-3.07-8.67A2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.28-1.28a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </svg>
            </div>
            <div>
              <div className="contact-label">Телефон</div>
              <div className="contact-val">
                <a href="tel:+79819656888" className="phone-link">+7 (981) 965-68-88</a>
              </div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <div>
              <div className="contact-label">Email</div>
              <div className="contact-val">
                <a href="mailto:Evroazia_sale@mail.ru">zakaz@yutongoriginal.ru</a>
              </div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div>
              <div className="contact-label">Адрес</div>
              <div className="contact-val">Санкт-Петербург,<br/>Предпортовая ул., 8Т, склад № 17</div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div>
              <div className="contact-label">Режим работы</div>
              <div className="contact-val">Пн – Пт: 09:00 – 18:00<br/><span style={{color:'#64748b'}}>Сб, Вс — выходной</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <hr className="footer-divider" />
      <div className="footer-bottom">
        <div className="footer-copy">© 2026 Yutong Original. Все права защищены.</div>
        <div className="footer-links">
          <a href="/privacy">Политика конфиденциальности</a>
          <a href="/terms">Пользовательское соглашение</a>
        </div>
        <div className="footer-dev">yutongoriginal.ru</div>
      </div>

    </div>
  </footer>






)


}